import { page } from '$app/state';

export function shouldShowEmailCapture(): boolean {
	const wasDismissedInSession = sessionStorage.getItem('mill-modal-dismissed') !== null;

	if (wasDismissedInSession) return false;

	const utmMedium = page.url.searchParams.get('utm_medium');

	if (utmMedium === 'email') return false;

	const utmSource = page.url.searchParams.get('utm_source');

	if (utmSource === 'friendbuy' || utmSource === 'mill') return false;

	return true;
}
